export default "__VITE_ASSET__DJk6DRiL__"